const tabTransitionDurationMs = 250;
const wrapperCls = "c2lwgrc02n";
const tabsCls = "c2lt1up4zx1";
const tabUnderlineCls = "c2ltzodxjt";
const tabToggleCls = "c2lt1gl17j0";
const tabCls = "c2lt6ox13l";
const tabMessageCls = "c2ltz6536j";
const shareButtonCls = "c2ls1jb5c69";

export { shareButtonCls, tabCls, tabMessageCls, tabToggleCls, tabTransitionDurationMs, tabUnderlineCls, tabsCls, wrapperCls };
import "./share-section.style.linaria.module.css";
//# sourceMappingURL=share-section.style.js.map
